!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("classnames")) : t(e.react, e.classnames);

    for (var o in n) {
      ("object" == typeof exports ? exports : e)[o] = n[o];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var i = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(o, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 116);
  }({
    0: function _(t, n) {
      t.exports = e;
    },
    1: function _(e, n) {
      e.exports = t;
    },
    116: function _(e, t, n) {
      "use strict";

      var _o,
          i = this && this.__extends || (_o = function o(e, t) {
        return (_o = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          r = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var a = r(n(0)),
          s = r(n(1)),
          c = n(153),
          u = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          n.handleKeyDown = function (e) {
            n.foundation.handleKeyDown(e.nativeEvent);
          }, n.handleActionClick = function (e) {
            n.foundation.handleActionButtonClick(e.nativeEvent);
          };
          var o = n.props,
              i = o.timeoutMs,
              r = o.closeOnEscape,
              a = o.leading,
              s = o.stacked,
              u = new Set();
          return a && u.add("mdc-snackbar--leading"), s && u.add("mdc-snackbar--stacked"), n.state = {
            classes: u
          }, n.foundation = new c.MDCSnackbarFoundation(n.adapter), i && n.foundation.setTimeoutMs(i), r && n.foundation.setCloseOnEscape(r), n;
        }

        return i(t, e), Object.defineProperty(t.prototype, "adapter", {
          get: function get() {
            var e = this;
            return {
              addClass: function addClass(t) {
                var n = e.state.classes;
                n.add(t), e.setState({
                  classes: n
                });
              },
              removeClass: function removeClass(t) {
                var n = e.state.classes;
                n.delete(t), e.setState({
                  classes: n
                });
              },
              announce: function announce() {
                e.props.onAnnounce && e.props.onAnnounce();
              },
              notifyOpening: function notifyOpening() {
                var t = e.props.onOpening;
                t && t();
              },
              notifyOpened: function notifyOpened() {
                var t = e.props.onOpen;
                t && t();
              },
              notifyClosing: function notifyClosing(t) {
                var n = e.props.onClosing;
                n && n(t);
              },
              notifyClosed: function notifyClosed(t) {
                var n = e.props.onClose;
                n && n(t);
              }
            };
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.close = function (e) {
          this.foundation.close(e);
        }, t.prototype.getTimeoutMs = function () {
          return this.foundation.getTimeoutMs();
        }, t.prototype.getCloseOnEscape = function () {
          return this.foundation.getCloseOnEscape();
        }, t.prototype.isOpen = function () {
          return this.foundation.isOpen();
        }, t.prototype.componentDidMount = function () {
          this.foundation.init(), this.props.open && this.foundation.open();
        }, t.prototype.componentDidUpdate = function (e) {
          var t = this.props,
              n = t.open,
              o = t.reason;
          e.open !== n && (n ? this.foundation.open() : this.foundation.close(o || ""));
        }, t.prototype.componentWillUnmount = function () {
          this.foundation.destroy();
        }, Object.defineProperty(t.prototype, "classes", {
          get: function get() {
            return s.default.apply(void 0, [this.props.className, "mdc-snackbar"].concat(Array.from(this.state.classes)));
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.render = function () {
          return a.default.createElement("div", {
            className: this.classes,
            onKeyDown: this.handleKeyDown
          }, a.default.createElement("div", {
            className: "mdc-snackbar__surface"
          }, a.default.createElement("div", {
            className: "mdc-snackbar__label",
            role: "status",
            "aria-live": "polite"
          }, this.props.message), this.props.actionText ? a.default.createElement("div", {
            className: "mdc-snackbar__actions"
          }, a.default.createElement("button", {
            type: "button",
            onClick: this.handleActionClick,
            className: "mdc-button mdc-snackbar__action"
          }, this.props.actionText)) : null));
        }, t.defaultProps = {
          open: !0,
          stacked: !1,
          leading: !1
        }, t;
      }(a.default.Component);

      t.Snackbar = u;
    },
    153: function _(e, t, n) {
      "use strict";

      n.r(t);
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _o2 = function o(e, t) {
        return (_o2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      var _i = function i() {
        return (_i = Object.assign || function (e) {
          for (var t, n = 1, o = arguments.length; n < o; n++) {
            for (var i in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            }
          }

          return e;
        }).apply(this, arguments);
      };
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */


      var r = function () {
        function e(e) {
          void 0 === e && (e = {}), this.adapter_ = e;
        }

        return Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "strings", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {}, e.prototype.destroy = function () {}, e;
      }(),
          a = {
        CLOSING: "mdc-snackbar--closing",
        OPEN: "mdc-snackbar--open",
        OPENING: "mdc-snackbar--opening"
      },
          s = {
        ACTION_SELECTOR: ".mdc-snackbar__action",
        ARIA_LIVE_LABEL_TEXT_ATTR: "data-mdc-snackbar-label-text",
        CLOSED_EVENT: "MDCSnackbar:closed",
        CLOSING_EVENT: "MDCSnackbar:closing",
        DISMISS_SELECTOR: ".mdc-snackbar__dismiss",
        LABEL_SELECTOR: ".mdc-snackbar__label",
        OPENED_EVENT: "MDCSnackbar:opened",
        OPENING_EVENT: "MDCSnackbar:opening",
        REASON_ACTION: "action",
        REASON_DISMISS: "dismiss",
        SURFACE_SELECTOR: ".mdc-snackbar__surface"
      },
          c = {
        DEFAULT_AUTO_DISMISS_TIMEOUT_MS: 5e3,
        MAX_AUTO_DISMISS_TIMEOUT_MS: 1e4,
        MIN_AUTO_DISMISS_TIMEOUT_MS: 4e3,
        SNACKBAR_ANIMATION_CLOSE_TIME_MS: 75,
        SNACKBAR_ANIMATION_OPEN_TIME_MS: 150,
        ARIA_LIVE_DELAY_MS: 1e3
      };

      n.d(t, "MDCSnackbarFoundation", function () {
        return m;
      });
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      var u = a.OPENING,
          p = a.OPEN,
          f = a.CLOSING,
          l = s.REASON_ACTION,
          d = s.REASON_DISMISS,
          m = function (e) {
        function t(n) {
          var o = e.call(this, _i({}, t.defaultAdapter, n)) || this;
          return o.isOpen_ = !1, o.animationFrame_ = 0, o.animationTimer_ = 0, o.autoDismissTimer_ = 0, o.autoDismissTimeoutMs_ = c.DEFAULT_AUTO_DISMISS_TIMEOUT_MS, o.closeOnEscape_ = !0, o;
        }

        return function (e, t) {
          function n() {
            this.constructor = e;
          }

          _o2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }(t, e), Object.defineProperty(t, "cssClasses", {
          get: function get() {
            return a;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "strings", {
          get: function get() {
            return s;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "numbers", {
          get: function get() {
            return c;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "defaultAdapter", {
          get: function get() {
            return {
              addClass: function addClass() {},
              announce: function announce() {},
              notifyClosed: function notifyClosed() {},
              notifyClosing: function notifyClosing() {},
              notifyOpened: function notifyOpened() {},
              notifyOpening: function notifyOpening() {},
              removeClass: function removeClass() {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.destroy = function () {
          this.clearAutoDismissTimer_(), cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, clearTimeout(this.animationTimer_), this.animationTimer_ = 0, this.adapter_.removeClass(u), this.adapter_.removeClass(p), this.adapter_.removeClass(f);
        }, t.prototype.open = function () {
          var e = this;
          this.clearAutoDismissTimer_(), this.isOpen_ = !0, this.adapter_.notifyOpening(), this.adapter_.removeClass(f), this.adapter_.addClass(u), this.adapter_.announce(), this.runNextAnimationFrame_(function () {
            e.adapter_.addClass(p), e.animationTimer_ = setTimeout(function () {
              e.handleAnimationTimerEnd_(), e.adapter_.notifyOpened(), e.autoDismissTimer_ = setTimeout(function () {
                e.close(d);
              }, e.getTimeoutMs());
            }, c.SNACKBAR_ANIMATION_OPEN_TIME_MS);
          });
        }, t.prototype.close = function (e) {
          var t = this;
          void 0 === e && (e = ""), this.isOpen_ && (cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, this.clearAutoDismissTimer_(), this.isOpen_ = !1, this.adapter_.notifyClosing(e), this.adapter_.addClass(a.CLOSING), this.adapter_.removeClass(a.OPEN), this.adapter_.removeClass(a.OPENING), clearTimeout(this.animationTimer_), this.animationTimer_ = setTimeout(function () {
            t.handleAnimationTimerEnd_(), t.adapter_.notifyClosed(e);
          }, c.SNACKBAR_ANIMATION_CLOSE_TIME_MS));
        }, t.prototype.isOpen = function () {
          return this.isOpen_;
        }, t.prototype.getTimeoutMs = function () {
          return this.autoDismissTimeoutMs_;
        }, t.prototype.setTimeoutMs = function (e) {
          var t = c.MIN_AUTO_DISMISS_TIMEOUT_MS,
              n = c.MAX_AUTO_DISMISS_TIMEOUT_MS;
          if (!(e <= n && e >= t)) throw new Error("timeoutMs must be an integer in the range " + t + "–" + n + ", but got '" + e + "'");
          this.autoDismissTimeoutMs_ = e;
        }, t.prototype.getCloseOnEscape = function () {
          return this.closeOnEscape_;
        }, t.prototype.setCloseOnEscape = function (e) {
          this.closeOnEscape_ = e;
        }, t.prototype.handleKeyDown = function (e) {
          ("Escape" === e.key || 27 === e.keyCode) && this.getCloseOnEscape() && this.close(d);
        }, t.prototype.handleActionButtonClick = function (e) {
          this.close(l);
        }, t.prototype.handleActionIconClick = function (e) {
          this.close(d);
        }, t.prototype.clearAutoDismissTimer_ = function () {
          clearTimeout(this.autoDismissTimer_), this.autoDismissTimer_ = 0;
        }, t.prototype.handleAnimationTimerEnd_ = function () {
          this.animationTimer_ = 0, this.adapter_.removeClass(a.OPENING), this.adapter_.removeClass(a.CLOSING);
        }, t.prototype.runNextAnimationFrame_ = function (e) {
          var t = this;
          cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = requestAnimationFrame(function () {
            t.animationFrame_ = 0, clearTimeout(t.animationTimer_), t.animationTimer_ = setTimeout(e, 0);
          });
        }, t;
      }(r);

      t.default = m;
    }
  });
});